import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    year: 2021,
    sxi: null,
    sex: null,
    sxy: null,
    base: null,
    sxArr: [
      "鼠",
      "牛",
      "虎",
      "兔",
      "龙",
      "蛇",
      "马",
      "羊",
      "猴",
      "鸡",
      "狗",
      "猪"
    ],
    sexeArr: ["female", "male"],
    sextArr: ["女", "男"],
    sxLoad: true,
    sxYear: null, //同年份生不
    sxId: null, //生肖对应ID
    apiUrl: "https://api.qxtky.com",
    imgUrl: "https://shop2020-1251134852.cos.ap-guangzhou.myqcloud.com/",
    gridState: false, //生肖选择框
    //生肖运程数据
    sxyc: null,
    from: null,
    sellid: null,
    token: null,
    dsShow: false,
    // 问答
    askShow: false,
    askCate: [
      { id: "1", title: "财运" },
      { id: "2", title: "事业" },
      { id: "3", title: "健康" },
      { id: "4", title: "爱情" },
      { id: "5", title: "家庭" },
      { id: "6", title: "女子" },
      { id: "7", title: "父母" },
      { id: "8", title: "名字" }
    ]
  },
  mutations: {
    setIsLoad: (state, isload) => (state.sxLoad = isload),
    setBase(satae, payload) {
      satae.base = payload.base;
      satae.sxYear = payload.years;
      satae.sxId = payload.sxid;
      satae.sxyc = payload.sxyc;
    },
    setSxi: (state, sxi) => (state.sxi = sxi),
    setSex: (state, sex) => (state.sex = sex),
    setSxy: (state, sxy) => (state.sxy = sxy),
    setYear: (state, year) => (state.year = year),
    setGridState: (state, status) => (state.gridState = status),
    setDsShow: (state, status) => (state.dsShow = status),
    setAskShow: (state, status) => (state.askShow = status),
    setAskCate: (state, cate) => (state.askCate = cate),
    //设置销售ID
    setSellid: (state, sellid) => (state.sellid = sellid),
    setFrom: (state, from) => (state.from = from),
    setToken(state, token) {
      state.token = token;
    }
  },
  getters: {
    sxt: state => state.sxArr[state.sxi] || "",
    sexe: state => state.sexeArr[state.sex] || "",
    sext: state => state.sextArr[state.sex] || "",
    sxQry(state) {
      let qry = {
        year: state.year
      };
      if (state.sxi) {
        qry.sxi = state.sxi;
      }
      if (state.sex) {
        qry.sex = state.sex;
      }
      if (state.sxy) {
        qry.sxy = state.sxy;
      }
      return qry;
    },
    //生肖对象
    sxObj(state) {
      let imgs = [];
      state.sxArr.forEach((sxt, i) => {
        imgs.push({
          sxt,
          img: require("./assets/sx/sx_" + i + ".png")
        });
      });
      return imgs;
    }
  },
  actions: {}
});

export default store;
